import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../context";
import LandingPage from "./LandingPage";

/**
 * HomeRedirect - Handles routing logic for the home page
 *
 * - If user is logged in with a team: redirect to team dashboard
 * - If user is logged in without a team: redirect to general dashboard
 * - If user is not logged in: show landing page
 */
export default function HomeRedirect(): React.ReactElement {
  const navigate = useNavigate();
  const { user, team } = useAppContext();

  useEffect(() => {
    if (user) {
      // User is logged in
      if (team && team.slug) {
        // Redirect to team dashboard
        navigate(`/a/${team.slug}/`, { replace: true });
      } else {
        // Redirect to general dashboard
        navigate("/dashboard", { replace: true });
      }
    }
    // If no user, component will render LandingPage below
  }, [user, team, navigate]);

  // Show landing page only if user is not logged in
  if (!user) {
    return <LandingPage />;
  }

  // Return null while redirecting (user will see brief loading)
  return null;
}
